export enum AdyenRoutesName {
  LOGIN = "LOGIN",
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  RESET_PASSWORD = "RESET_PASSWORD",
  DASHBOARD = "DASHBOARD",
  DASHBOARD_MARKETPLACES = "DASHBOARD_MARKETPLACES",
  DASHBOARD_REPORTS = "DASHBOARD_REPORTS",
  DASHBOARD_USERS = "DASHBOARD_USERS",
  DASHBOARD_LOGS = "DASHBOARD_LOGS",
  DASHBOARD_FIRST_MARKETPLACE = "DASHBOARD_FIRST_MARKETPLACE",
  EDIT_MARKETPLACE = "EDIT_MARKETPLACE",
  HOP_AUTH = "HOP_AUTH",
  HOP = "HOP",
  MARKETPLACE_LOGS = "MARKETPLACE_LOGS",
  BOARDING_TUTORIAL = "BOARDING_TUTORIAL",
  MARKETPLACE_CONTROL = "MARKETPLACE_CONTROL",
  LOGIN_WITH_MIRAKL = "LOGIN_WITH_MIRAKL"
}
